import type { MessagingChannelsCopy } from './types';

export const FR: MessagingChannelsCopy = {
  title: 'Messagerie',
  description:
    'Parlez à IMAI depuis les applications de chat que vous utilisez déjà. Connectez-vous une fois, puis écrivez à IMAI là-bas.',
  privacy:
    'Les messages de vos comptes connectés s’exécutent en votre nom dans cet espace de travail et utilisent vos crédits.',
  loading: 'Chargement des canaux de messagerie',
  unavailable: 'Pas encore disponible',
  unavailableNote: '{channel} n’est pas encore configuré pour IMAI.',
  connectedBadge: 'Connecté',
  cancel: 'Annuler',

  phoneTitle: 'Numéro de téléphone',
  phoneNote: 'Connectez WhatsApp ou iMessage avec votre numéro de téléphone.',
  phoneUnavailableNote: 'Les SMS avec IMAI ne sont pas encore configurés.',
  addNumber: 'Ajouter un numéro',
  countryLabel: 'Indicatif du pays',
  countrySearch: 'Rechercher un pays ou un indicatif…',
  countryEmpty: 'Aucun pays trouvé.',
  numberLabel: 'Numéro de téléphone',
  numberPlaceholder: 'Numéro de téléphone',
  numberHint:
    'Votre pays n’est pas listé ? Saisissez le numéro complet en commençant par +.',
  continueActivation: 'Continuer',
  editNumber: 'Changer de numéro',
  activateQr: 'Scannez et envoyez pour vous connecter.',
  activateTitle: 'Envoyez un message sur WhatsApp',
  activateHint:
    'Touchez le bouton et envoyez le message déjà rédigé pour vous.',
  activateSentFrom: 'Envoyez-le depuis le {number}.',
  activateButton: 'Ouvrir {channel}',
  activateManual: 'Ou envoyez {message} au {number} sur WhatsApp.',
  activateWaiting: 'En attente de votre message. Expire dans {time}.',
  startAgain: 'Recommencer',
  verifiedBadge: 'Vérifié',
  verifiedOn: 'Vérifié le {date}',
  change: 'Modifier',
  changeAria: 'Modifier le numéro {number}',
  remove: 'Supprimer',
  removeAria: 'Supprimer le numéro {number}',
  messageImai: 'Écrire à IMAI',
  messageImaiAria: 'Écrire à IMAI sur {channel}',
  removeTitle: 'Supprimer {number} ?',
  removeDescription:
    'IMAI ne répondra plus à ce numéro sur iMessage et WhatsApp. Vous pourrez l’ajouter de nouveau à tout moment.',
  removeError: 'Impossible de supprimer le numéro. Réessayez.',

  errorInvalidNumber: 'Saisissez un numéro valide, avec l’indicatif régional.',
  errorNumberTaken: 'Ce numéro est déjà utilisé par un autre compte IMAI.',
  errorRateLimited: 'Trop de tentatives. Patientez un moment, puis réessayez.',
  errorChannelUnavailable:
    'Cette option n’est pas disponible pour le moment. Choisissez l’autre.',
  errorSendFailed: 'Impossible de lancer la vérification. Réessayez.',
  errorActivationExpired: 'Cette activation a expiré. Recommencez.',

  noteSlack: 'Écrivez à IMAI depuis votre espace de travail Slack.',
  noteTeams: 'Écrivez à IMAI depuis Microsoft Teams.',
  noteTelegram: 'Discutez avec le bot IMAI sur Telegram.',
  connect: 'Connecter',
  connectAria: 'Connecter {channel}',
  connectError: 'Impossible de lancer la connexion à {channel}. Réessayez.',
  connectedOn: 'Connecté le {date}',
  accountFallback: 'Votre compte {channel}',
  installSlack: 'Ajouter IMAI à votre espace de travail',
  installTeams: 'Ajouter IMAI à Teams',
  openTelegram: 'Ouvrir dans Telegram',
  disconnect: 'Déconnecter',
  disconnectAria: 'Déconnecter {account} de {channel}',
  disconnectError: 'Impossible de déconnecter {channel}. Réessayez.',
  disconnectTitle: 'Déconnecter {channel} ?',
  disconnectDescription:
    'Les messages de {account} n’arriveront plus à IMAI. Vous pourrez le reconnecter à tout moment.',

  toastConnected: '{channel} connecté',
  toastConnectedGeneric: 'Compte connecté',
  toastErrorExpired: 'La connexion a pris trop de temps. Réessayez.',
  toastErrorInvalidState: 'Ce lien de connexion n’est plus valide. Réessayez.',
  toastErrorAccountTaken:
    'Ce compte est déjà connecté à un autre utilisateur IMAI.',
  toastErrorNotMember: 'Vous n’êtes plus membre de cet espace de travail.',
  toastErrorProvider: 'La connexion n’a pas abouti. Réessayez.',
  toastErrorGeneric: 'Impossible de connecter le compte. Réessayez.',
};
